import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const convertMoney = (value) => {
  return value.toLocaleString('pt-br', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

const DisplayCash = ({ price }) => (
  <Fragment>
    <div className='card-price-points txt-initial col-12 txt-title txt-font-body-bold txt-left color-ui-1 nowrap' title={'R$ ' + convertMoney(price)}>
      {'R$ ' + convertMoney(price)}
    </div>
    <div className='card-price-currency col-12 txt-body txt-font-body-bold txt-center color-ui-1' />
  </Fragment>
)

DisplayCash.propTypes = {
  price: PropTypes.number
}

export default DisplayCash



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/ProductAvailability/PriceLabel/DisplayCash.js